import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	.public-layout-articles-breadcrumbs {
		padding-top: 4em;

		.breadcrumbs-list {
			font-size: 1.2em;
		}
	}

	.article-main {
		margin-top: -1em;

		.header {
			display: flex;
			justify-content: space-between;
			align-items: flex-start;

			.headline {
				margin-bottom: 1.2em;
			}
		}

		.lead {
			font-size: 1.1em;
			font-weight: 700;
			margin-bottom: 3em;
		}

		.article-image {
			margin-bottom: 3em;
			width: 100%;
			max-height: 25em;
			object-fit: cover;
		}

		.article-txt {
			font-size: 1em;

			h2 {
				font-size: 1.1em;
				margin-bottom: 1.3em;
			}
			h3 {
				font-size: 1em;
				margin-bottom: 1.2em;
			}
			p {
				margin-bottom: 2em;
			}
		}
	}
	.se-video-container {
		position: relative;
		width: min(100%, 50em) !important;

		margin: 0 auto 1em;
		figure {
			display: contents;

		}
		iframe {
			display: block;
			border: none;
			padding: 0;
			&[src*="youtube"] {
				height: 30em !important;
			}
		}
	}
	.article-sponsor {
		color: ${vars.colorTextLighter};
		padding: 1em 0 1em 0;
	}

	.second-article-wrapper {
		background-color: ${vars.colorBackgroundContrastDark};
	}

	.article-second {
		background-color: ${vars.colorBackgroundContrastDark};
	}
	@media all and (max-width: ${vars.tabletL}) {
		.se-video-container {
			iframe {
				&[src*="youtube"] {
					height: 56vw!important;
				}

			}
		}
	}
`;
